<div class="container">
  <div class="custom-popup mx-3">
      <div class="px-2">
          <ng-content></ng-content>
      </div>
      <div *ngIf="isConfirmation" class="">
          <div class="pt-3">
              <div class="d-flex justify-content-between">
                  <div>
                      <button (click)="reject.emit()" class="btn btn-danger px-5">{{ rejectLabel }}</button>
                  </div>
                  <div>
                      <button (click)="accept.emit()" class="btn btn-primary px-5">{{ acceptLabel }}</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
